<template>
  <div id="border">
    <div class="payDetail">
      <el-row class="bottom_row">
        <span class="pay_title">充值、续费方式</span>
      </el-row>
      <el-row class="bottom_row">
          <el-col :span="12">
              <span class="pay_content">公司名称：</span>易筑网络科技(苏州)有限公司
          </el-col>
          <el-col :span="12">
              <span class="pay_content">开户银行：</span>农业银行苏州斜塘支行
          </el-col>
      </el-row>
      <el-row class="bottom_row">
          <el-col :span="12">
              <span class="pay_content">银行账号：</span>10550701040016807
          </el-col>
          <el-col :span="12">
              <span class="pay_content">联系电话：</span>13913105327
          </el-col>
      </el-row>
    </div>
    <div>
        <el-card class="box-card" shadow="hover" v-for="(module,i) in moduleList">
            <div slot="header" class="clearfix">
                <span class="pay_title" v-if="module.account_module === 1">
                    软件基础模块
                </span>
                <span class="pay_title" v-if="module.account_module === 2">
                    BI系统
                </span>
                <span class="pay_title" v-if="module.account_module === 3">
                    企查查基础数据
                </span>
                <span class="pay_title" v-if="module.account_module === 4">
                    企查查风险监控
                </span>
                <span class="pay_title" v-if="module.account_module === 5">
                    税务发票信息
                </span>
                <span class="pay_title" v-if="module.account_module === 6">
                    凭证推送
                </span>
                <span class="pay_title" v-if="module.account_module === 7">
                    支付宝接口
                </span>
                <span class="pay_title" v-if="module.account_module === 8">
                    OCR
                </span>
                <span class="pay_title" v-if="module.account_module === 9">
                    招行CBS
                </span>
                <span class="pay_title" v-if="module.account_module === 10">
                    E签宝
                </span>
                <el-switch
                    v-model="module.open_status"
                    style="float: right; padding: 3px 0"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                    @change="changeState(module)"
                    v-if="isShow">
                </el-switch>
            </div>
            <div class="text item">
                <el-row class="bottom_row">
                    <el-col :span="16" class="pay_content">
                        初次开通时间：
                    </el-col>
                    <el-col :span="8">
                        {{module.initial_open_time}}
                    </el-col>
                </el-row>
                <el-row class="bottom_row">
                    <el-col :span="16" class="pay_content">
                        费用到期日：
                    </el-col>
                    <el-col :span="8">
                        {{module.expire_time}}
                    </el-col>
                </el-row>
                <el-row class="bottom_row">
                    <el-col :span="16" class="pay_content">
                        累计使用天数：
                    </el-col>
                    <el-col :span="8">
                        {{module.totalUseDays}}
                    </el-col>
                </el-row>
                <el-row class="bottom_row">
                    <el-col :span="16" class="pay_content">
                        剩余天数：
                    </el-col>
                    <el-col :span="8">
                        {{module.remainDays}}
                    </el-col>
                </el-row>
                <el-row class="bottom_row">
                    <el-col :span="16" class="pay_content">
                        目前状态：
                    </el-col>
                    <el-col :span="8">
                        <div v-if="module.pay_status == 0" style="color: red">欠费</div>
                        <div v-if="module.pay_status == 1">正常</div>
                    </el-col>
                </el-row>

            </div>
            <div class="bottom clearfix">
                <el-button v-if="module.account_module === 5" circle size="mini" icon="el-icon-edit" @click="showtaxNo(module)"></el-button>
                <el-button v-if="module.account_module === 6" circle size="mini" icon="el-icon-edit" @click="showNcConfig(module)"></el-button>
                <el-button v-if="module.account_module === 7" circle size="mini" icon="el-icon-edit" @click="showZfbConfig(module)"></el-button>
                <el-button v-if="module.account_module === 9" circle size="mini" icon="el-icon-edit" @click="showCbsConfig(module)"></el-button>
                <el-button v-if="isShow" circle size="mini" icon="el-icon-bank-card" @click="showRecharge(module.account_module)"></el-button>
                <el-button circle size="mini" icon="el-icon-document" @click="showRecord(module.account_module)"></el-button>
<!--                <el-button circle size="mini" icon="el-icon-edit"></el-button>-->
            </div>
        </el-card>
    </div>


    <!--充值-->
      <el-dialog
          :close-on-click-modal="false"
          width="50%"
          :title="recharge.title"
          :visible="showDetail"
          :before-close="beforeCloseDialog"
          append-to-body
          v-loading="loading">
          <div slot="title" class="dialog-header-title">
              <span class="name">{{ recharge.title }}</span>
          </div>
          <div class="content">
              <el-row style="height: 4rem">
                  <el-col :span="12">
                      <el-row>
                          <el-col :span="6">
                              <span style="color: red" v-if="recharge.startTime == ''">*</span>开始时间：
                          </el-col>
                          <el-col :span="18">
                              <el-date-picker
                                      v-model="recharge.startTime"
                                      align="right"
                                      type="date"
                                      placeholder="选择日期"
                                      value-format="yyyy-MM-dd"
                              >
                              </el-date-picker>
                          </el-col>
                      </el-row>
                  </el-col>
                  <el-col :span="12">
                      <el-row>
                          <el-col :span="6">
                            <span style="color: red" v-if="recharge.endTime == ''">*</span>结束时间：
                          </el-col>
                          <el-col :span="18">
                              <el-date-picker
                                      v-model="recharge.endTime"
                                      align="right"
                                      type="date"
                                      placeholder="选择日期"
                                      value-format="yyyy-MM-dd">
                              </el-date-picker>
                          </el-col>
                      </el-row>
                  </el-col>
              </el-row>
              <el-row style="height: 4rem">
                  <el-col :span="12">
                      <el-row>
                          <el-col :span="6">
                              <span style="color: red" v-if="recharge.amount == ''">*</span>充值金额(元)：
                          </el-col>
                          <el-col :span="18">
                              <el-input-number
                                      v-model="recharge.amount"
                                      :controls="false"
                                      :precision="2"
                                      :min="0"
                                      :max="9999999999">
                              </el-input-number>
                          </el-col>
                      </el-row>
                  </el-col>
              </el-row>
              <el-row style="height: 4rem">
                  <el-col>
                      <el-row>
                          <el-col :span="3">备注：</el-col>
                          <el-col :span="19">
                              <el-input
                                      v-model="recharge.remarks"
                                      placeholder=" "
                                      clearable
                                      maxlength="200"
                                      show-word-limit
                                      type="textarea">
                              </el-input>
                          </el-col>
                      </el-row>
                  </el-col>
              </el-row>
              <el-row style="height: 4rem; margin-top: 2rem">
                  <el-col :span="12">
                      <el-row>
                          <el-col :span="6"> 编制人：</el-col>
                          <el-col :span="8">
                              <el-input
                                      v-model="recharge.currentUser"
                                      placeholder=" "
                                      disabled>
                              </el-input>
                          </el-col>
                      </el-row>
                  </el-col>
                  <el-col :span="12">
                      <el-row>
                          <el-col :span="4"> 编制时间： </el-col>
                          <el-col :span="20">
                              <el-date-picker
                                      v-model="recharge.createTime"
                                      align="right"
                                      type="datetime"
                                      placeholder="选择日期"
                                      disabled>
                              </el-date-picker>
                          </el-col>
                      </el-row>
                  </el-col>
              </el-row>
          </div>
          <div class="bottom">
              <el-button type="primary" @click="saveRecharge">确定</el-button>
              <el-button @click="showDetail = false">取消</el-button>
          </div>
      </el-dialog>
      <el-dialog
              :close-on-click-modal="false"
              width="50%"
              :title="title"
              :visible="showTaxNo"
              :before-close="beforeCloseDialog1"
              append-to-body
              v-loading="loading"
      >
          <div slot="title" class="dialog-header-title">
              <span class="name">{{ title }}</span>
          </div>
          <div class="content">
              <el-row style="height: 4rem">
                  <el-col :span="12">
                      <el-row>
                          <el-col :span="2"> 税号</el-col>
                          <el-col :span="20">
                              <el-input v-model="tax.taxNo" placeholder=" " clearable></el-input>
                          </el-col>
                      </el-row>
                  </el-col>
              </el-row>
          </div>
          <div class="bottom">
              <el-button type="primary" @click="saveTaxNo">确定</el-button>
              <el-button @click="showTaxNo = false">取消</el-button>
          </div>
      </el-dialog>

      <el-dialog
              :close-on-click-modal="false"
              width="50%"
              :title="title"
              :visible="showNcType"
              :before-close="beforeCloseDialog2"
              append-to-body
              v-loading="loading"
      >
          <div slot="title" class="dialog-header-title">
              <span class="name">{{ title }}</span>
          </div>
          <div class="content">
              <el-row style="height: 4rem">
                  <el-col :span="4">系统类型</el-col>
                  <el-col :span="20">
                      <el-select v-model="ncConfig.ncType" placeholder="请选择">
                          <el-option label="K3" value="k3"></el-option>
                      </el-select>
                  </el-col>
              </el-row>
              <el-row style="height: 4rem">
                  <el-col :span="4">对接地址</el-col>
                  <el-col :span="20">
                      <el-input v-model="ncConfig.ncUrl" placeholder="" clearable></el-input>
                  </el-col>
              </el-row>
          </div>
          <div class="bottom">
              <el-button type="primary" @click="saveNc">确定</el-button>
              <el-button @click="showNcType = false">取消</el-button>
          </div>
      </el-dialog>
      <el-dialog
              :close-on-click-modal="false"
              width="50%"
              :title="title"
              :visible="showZfb"
              :before-close="beforeCloseZfbDialog"
              append-to-body
              v-loading="loading"
      >
          <div slot="title" class="dialog-header-title">
              <span class="name">{{ title }}</span>
          </div>
          <div class="content">
              <el-row style="height: 4rem">
                  <el-col :span="12">
                      <el-row>
                          <el-col :span="8">绑定支付宝账号</el-col>
                          <el-col :span="14">
                              <el-input
                                      v-model="zfb.zfbAccount"
                                      placeholder=""
                                      clearable
                              ></el-input>
                          </el-col>
                      </el-row>
                  </el-col>
                  <el-col :span="12">
                      <el-row>
                          <el-col :span="8">账户名称</el-col>
                          <el-col :span="14">
                              <el-input v-model="zfb.zfbName" placeholder="" clearable></el-input>
                          </el-col>
                      </el-row>
                  </el-col>
              </el-row>
              <el-row style="height: 4rem">
                  <el-col :span="4">备注</el-col>
                  <el-col :span="20">
                      <el-input v-model="zfb.fbRemarkes" placeholder="" clearable></el-input>
                  </el-col>
              </el-row>
              <el-row style="height: 4rem">
                  <el-col :span="24">
                      1、您的企业支付宝<span style="color: #aa1111">未在</span>其他系统签约过 [支付宝批量转账接口]，请点击<span style="color: #aa1111">[签约授权一体]</span>按钮进行签约和授权。<br>
                      2、您的企业支付宝<span style="color: #aa1111">已经</span>在其他系统签约过 [支付宝批量转账接口]，请点击<span style="color: #aa1111">[授权]</span>按钮为易筑云平台进行授权。

                  </el-col>
              </el-row>
          </div>
          <div class="bottom">
              <el-button type="primary" @click="saveDataZfbSign">签约授权一体</el-button>
              <el-button type="primary" @click="saveDataZfbOauth">授权</el-button>
              <el-button @click="showZfb = false">取消</el-button>
          </div>
      </el-dialog>
      <!--招行CBS-->
      <el-dialog
          :close-on-click-modal="false"
          width="50%"
          :title="title"
          :visible="showCbsType"
          :before-close="beforeCloseCbsDialog"
          append-to-body
          v-loading="loading"
      >
        <div slot="title" class="dialog-header-title">
          <span class="name">{{ title }}</span>
        </div>
        <div class="content">
          <el-row style="height: 4rem">
            <el-col :span="4">企业号</el-col>
            <el-col :span="20">
              <el-input v-model="cbsConfig.cbsOrgNo" placeholder="" clearable></el-input>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="4">对接地址</el-col>
            <el-col :span="20">
              <el-input v-model="cbsConfig.cbsUrl" placeholder="" clearable></el-input>
            </el-col>
          </el-row>
        </div>
        <div class="bottom">
          <el-button type="primary" @click="saveCbs">确定</el-button>
          <el-button @click="showCbsType = false">取消</el-button>
        </div>
      </el-dialog>


      <el-drawer
          title="充值历史"
          :visible.sync="drawer"
          direction="rtl"
          :before-close="handleClose"
          append-to-body
      >
          <div class="drawer_content">
              <div class="noData_tips" v-if="!isHaving">暂无记录</div>
              <div v-for="item in chargeData" :key="item" v-else>
                  <charge-record :chargeData="item"></charge-record>
              </div>
          </div>
      </el-drawer>
  </div>
</template>

<script>
import chargeRecord from "./chargeRecord.vue";
const FeFileToUpload = () => import("@/components/common/FeFileToUpload.vue");
import req from "@/request.js";
export default {
  components: { chargeRecord, FeFileToUpload },
  props: ["tenantId"],
  data() {
    return {
      title:"",
      isShow: false,
      moduleList:{},
      moduleTitle:"",
      recharge:{
        accountModule:"",
        title:"",
        startTime:"",
        endTime:"",
        amount:"",
        remarks:"",
        currentUser:"",
        createTime:""
      },
      tax:{
        taxNo:""
      },
      ncConfig:{
        ncType:"",
        ncUrl:""
      },
      zfb: {
        zfbAccount:"",
        zfbName:"",
        zfbRemarkes:""
      },
      cbsConfig:{
        cbsOrgNo:"",
        cbsUrl:""
      },
      chargeData: [],
      showDetail:false,
      showTaxNo: false,
      showNcType: false,
      showZfb:false,
      showCbsType: false,
      drawer: false,
      isHaving: false,
      loading: false
    };
  },
  mounted() {
    this.getAccountMangement();
    if (this.$store.state.user.currentUserDetail.user.tenantId == "-1") {
      this.isShow = true;
    }
  },
  methods: {
    beforeCloseDialog() {
      this.showDetail = false;
    },
    beforeCloseDialog1() {
      this.showTaxNo = false;
    },
    beforeCloseDialog2() {
      this.showNcType = false;
    },
    beforeCloseZfbDialog() {
      this.showZfb = false;
    },
    beforeCloseCbsDialog() {
      this.showCbs = false;
    },
    handleClose() {
      this.drawer = false;
    },
    getAccountMangement() {
      req.get("${third}/system/account_mangement/getById?tenantId=" + this.tenantId)
          .then((res) => {
            let response = res.data;
            if (response && response.length > 0) {
              this.moduleList = response;
            }
          });
    },
    showNcConfig(module) {
      this.title = "凭证配置";
      this.ncConfig.ncType = module.tax_no;
      this.ncConfig.ncUrl = module.url;
      this.showNcType = true;
    },
    showtaxNo(module) {
      this.title = "税号";
      this.tax.taxNo = module.tax_no;
      this.showTaxNo = true;
    },
    showRecharge(account_module) {
      this.recharge = {
            accountModule:account_module,
            title:"",
            startTime:"",
            endTime:"",
            amount:"",
            remarks:"",
            currentUser:this.$store.state.user.currentUserDetail.user.fullname,
            createTime:new Date()
      };
      if (account_module === 1) {
        this.recharge.title = "软件基础模块充值";
      } else if (account_module === 2) {
        this.recharge.title = "BI模块充值";
      } else if (account_module === 3) {
        this.recharge.title = "企查查基础数据模块充值";
      } else if (account_module === 4) {
        this.recharge.title = "企查查风险监控模块充值";
      } else if (account_module === 5) {
        this.recharge.title = "税务发票模块充值";
      } else if (account_module === 6) {
        this.recharge.title = "凭证推送";
      } else if (account_module === 8) {
        this.recharge.title = "OCR";
      }
      this.showDetail = true;
    },
    showZfbConfig(module) {
      this.title = "绑定账号";
      this.zfb.zfbAccount = module.alipay_account;
      this.zfb.zfbName = module.alipay_name;
      this.zfb.zfbRemarkes = module.remark;
      this.showZfb = true;
    },
    showCbsConfig(module) {
      this.title = "CBS配置";
      this.cbsConfig.cbsOrgNo = module.tax_no;
      this.cbsConfig.cbsUrl = module.url;
      this.showCbsType = true;
    },
    saveTaxNo() {
      this.loading = true;
      let url =
          window.context.third +
          "/system/account_mangement/openOrCancelModule?tenantId=" +
          this.tenantId;
      let param = {
        accountModule: 5,
        openStatus: "",
        taxNo: this.tax.taxNo,
      };
      req.post(url, param).then((res) => {
        this.loading = false;
        this.showTaxNo = false;
        this.getAccountMangement();
      });
    },
    saveNc() {
      this.loading = true;
      let url =
          window.context.third +
          "/system/account_mangement/openOrCancelModule?tenantId=" +
          this.tenantId;
      let param = {
        accountModule: 6,
        openStatus: "",
        taxNo: this.ncConfig.ncType,
        url: this.ncConfig.ncUrl
      };
      req.post(url, param).then((res) => {
        this.loading = false;
        this.showNcType = false;
        this.getAccountMangement();
      });
    },
    saveRecharge() {
      this.loading = true;
      if (this.recharge.amount == "") {
        this.$message.info("充值金额不能为空！");
      } else {
        if (this.recharge.startTime == "") {
          this.$message.info("开始日期不能为空！");
        } else {
          if (this.recharge.endTime == "") {
            this.$message.info("结束日期不能为空！");
          } else {
            if (this.recharge.startTime && this.recharge.endTime) {
              let start = new Date(Date.parse(this.recharge.startTime));
              let end = new Date(Date.parse(this.recharge.endTime));
              if (start > end) {
                this.$message.info("结束日期不能早于开始日期！");
              } else {
                let url = window.context.third + "/system/recharge_record/";
                let param = {
                  account_module: this.recharge.accountModule,
                  end_time: this.recharge.endTime,
                  id: "",
                  recharge_money: this.recharge.amount,
                  remark: this.recharge.remarks,
                  start_time: this.recharge.startTime,
                  tenant_id_: this.tenantId,
                };
                req.post(url, param).then((res) => {
                  this.loading = false;
                  this.showDetail = false;
                  this.getAccountMangement();
                });
              }
            }
          }
        }
      }
    },
    saveDataZfbSign() {
      this.loading = true;
      if (!this.zfb.zfbAccount) {
        this.$message.info("支付宝帐号不能为空！");
      } else {
        if (!this.zfb.zfbName) {
          this.$message.info("支付宝名称不能为空！");
        } else {
          let url =
              window.context.third +
              "/system/account_mangement/openOrCancelModule?tenantId=" +
              this.tenantId;
          let param = {
            accountModule: 7,// 支付宝
            openStatus: "",
            alipayAccount: this.zfb.zfbAccount,
            alipayName: this.zfb.zfbName,
            remark: this.zfb.zfbRemarkes
          };
          req.post(url, param).then((res) => {
            this.loading = false;
            this.showZfb = false;
            if (res.data) {
              this.getAccountMangement();
              req.get("${third}/aliPay/openInviteOrderCreate").then(resf => {
                if (resf.data.success) {
                  window.open(resf.data.body)
                } else {
                  this.$message.error(resf.data.subMsg);
                }
              })
            }
          });
        }
      }

    },
    saveDataZfbOauth() {
      this.loading = true;
      if (!this.zfb.zfbAccount) {
        this.$message.info("支付宝帐号不能为空！");
      } else {
        if (!this.zfb.zfbName) {
          this.$message.info("支付宝名称不能为空！");
        } else {
          let url =
              window.context.third +
              "/system/account_mangement/openOrCancelModule?tenantId=" +
              this.tenantId;
          let param = {
            accountModule: 7,// 支付宝
            openStatus: "",
            alipayAccount: this.zfb.zfbAccount,
            alipayName: this.zfb.zfbName,
            remark: this.zfb.zfbRemarkes
          };
          req.post(url, param).then((res) => {
            this.loading = false;
            this.showZfb = false;
            if (res.data) {
              this.getAccountMangement();
              req.get(window.context.third + "/aliPay/toOauth","json")
                  .then((response) => {
                    window.open(response.data.message)
                  });
            }
          });
        }
      }
    },
    saveCbs() {
      this.loading = true;
      let url =
          window.context.third +
          "/system/account_mangement/openOrCancelModule?tenantId=" +
          this.tenantId;
      let param = {
        accountModule: 9,
        openStatus: "",
        taxNo: this.cbsConfig.cbsOrgNo,
        url: this.cbsConfig.cbsUrl
      };
      req.post(url, param).then((res) => {
        this.loading = false;
        this.showCbsType = false;
        this.getAccountMangement();
      });
    },
    showRecord(account_module) {
      this.isHaving = false;
      this.openStatus = "";
      if (account_module == 1) {
        this.title = "软件基础模块充值";
        this.account_module = 1;
        this.openStatus = true;
      } else if (account_module == 2) {
        this.title = "BI模块充值";
        this.account_module = 2;
        this.openStatus = this.bi_val;
      } else if (account_module == 3) {
        this.title = "企查查基础数据模块充值";
        this.account_module = 3;
        this.openStatus = this.base_val;
      } else if (account_module == 4) {
        this.title = "企查查风险监控模块充值";
        this.account_module = 4;
        this.openStatus = this.risk_val;
      } else if (account_module == 5) {
        this.title = "税务发票模块充值";
        this.account_module = 5;
        this.openStatus = this.ray_val;
      } else if (account_module == 6) {
        this.title = "凭证推送模块充值";
        this.account_module = 6;
        this.openStatus = this.nc_val;
      } else if (account_module == 7) {
        this.title = "支付宝绑定账号更换记录";
        this.account_module = 7;
        this.openStatus = this.nc_val;
      }
      let url = window.context.third +
          "/system/recharge_record/getRecordsByTenantIdAndModule";
      let param = {
        accountModule: account_module,
        openStatus: "",
        taxNo: "",
      };
      req.post(url, param).then((res) => {
        this.chargeData = [];
        let response = res.data;
        if (response.length > 0) {
          this.isHaving = true;
          response.forEach((item) => {
            let list = {
              createTime: item.createTime,
              createByName: item.createByName,
              start_time: item.start_time,
              end_time: item.end_time,
              recharge_money: item.recharge_money,
              remark: item.remark,
            };
            this.chargeData.push(list);
          });
        } else {
          this.isHaving = false;
        }

      });
      this.drawer = true;
    },
    changeState(module) {
      let url = window.context.third +
          "/system/account_mangement/openOrCancelModule?tenantId=" +
          this.tenantId;
      let param = {
        accountModule: module.account_module,
        openStatus: module.open_status,
        taxNo: "",
      };
      req.post(url, param).then((res) => {
        let response = res.data;
        if (response == true && module.open_status === 1) {
          this.$message.info("开启成功！");
          this.getAccountMangement();
        }
        if (response == true && module.open_status === 0) {
          this.$message.info("关闭成功！");
          this.getAccountMangement();
        }
      });
    },
  },
};
</script>

<style scoped>
    .payDetail {
        border: 1px solid #e4e7ed;
        height: 6rem;
        padding: 10px;
    }
    .pay_title {
        font-weight: bold;
        color: black;
        font-size: larger;
    }
    .bottom_row {
        height: 2rem;
        text-align: left;
        display: flex;
        align-items: center;
    }
    .pay_content {
        font-weight: bold;
        color: #3b97d7;
        font-size: larger;
    }
    .text {
        font-size: 14px;
    }
    .item {
        margin-bottom: 18px;
    }
    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    .clearfix:after {
        clear: both
    }
    .box-card {
        width: calc(25% - 13px);
        float: left;
        margin-top: 10px;
        margin-right: 10px;
    }
    .bottom {
        text-align: right;
    }
    .drawer_content {
        padding: 0px 20px;
    }
    .noData_tips {
        height: 100%;
        width: 100%;
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
    }
</style>